import ConfigFile from "../../../datasets/config_file";

export const buildOneTimeCostArr = (startingCash, extraCreditInfo, badgesInfo, homeCost, roommates,
        furnitureName, furnitureCost, kitchenCost, miscSupplies, carSize  ) => {
     let oneTimeCostArr = [];
     var oneTimeCostObj = {};

    oneTimeCostObj = {itemName: "Starting Cash", itemDesc: "Personal Savings Amount", 
            itemAmt: +startingCash, total: false};
    oneTimeCostArr.push(oneTimeCostObj);
    if (extraCreditInfo.extraCreditDesc){
         let oneTimeCostObj = {itemName: "Cash Earned", itemDesc: extraCreditInfo.extraCreditDesc, 
               itemAmt: +extraCreditInfo.cashAmt, total: false};
         oneTimeCostArr.push(oneTimeCostObj);
     }
     if (badgesInfo.badgesDesc){
         let oneTimeCostObj = {itemName: "Cash Earned", itemDesc: badgesInfo.badgesDesc, 
            itemAmt: +badgesInfo.cashAmt, total: false};
         oneTimeCostArr.push(oneTimeCostObj);
     }
     let damageDeposit = +homeCost;
     if (+roommates >= 1){
        damageDeposit = +homeCost / (+roommates + 1);
     }
     oneTimeCostObj = {itemName: "Apartment Damage Deposit", itemDesc: "1 month's rent", itemAmt: -damageDeposit,
        total: false};
     oneTimeCostArr.push(oneTimeCostObj);
   
     oneTimeCostObj = {itemName: "Furniture", itemDesc: furnitureName, itemAmt: -furnitureCost, total: false};
     oneTimeCostArr.push(oneTimeCostObj);

     oneTimeCostObj = {itemName: "Kitchen Supplies", 
        itemDesc: "Pots and Pans, Mixing Bowls, Dishes, Silverware, Kitchen Towels", itemAmt: -kitchenCost,
        total: false};
     oneTimeCostArr.push(oneTimeCostObj);

     if (carSize === 50){
         const bicycleCost = ConfigFile.gameStartItems.bicycleCost;
         oneTimeCostObj = {itemName: "Bicycle and Accessories", itemDesc: "Bicycle, Baskets, Lock",
            itemAmt: -bicycleCost, total: false };
         oneTimeCostArr.push(oneTimeCostObj);
         const walkingShoes = ConfigFile.gameStartItems.walkingShoes;
         oneTimeCostObj = {itemName: "Walking Shoes", itemDesc: "Comfortable Shoes for Walking",
            itemAmt: -walkingShoes, total: false };
         oneTimeCostArr.push(oneTimeCostObj);
     }

     oneTimeCostObj = {itemName: "Misc Supplies", 
      
        itemDesc: "Bath Towels, Bed Sheets, Cleaning Supplies", 
        itemAmt: -miscSupplies, total: false};
     oneTimeCostArr.push(oneTimeCostObj);

     
     return(oneTimeCostArr);
}
export default buildOneTimeCostArr;